import BaseComponentController from '../../../../components/base-component.controller';

class LineManagerSelectController extends BaseComponentController {

    constructor(_, componentRegistryService, $q, userService) {
        super(_, componentRegistryService, $q);
        this.componentRegistryService = componentRegistryService;
        this.userService = userService;
        this._ = _;
        this.vm = {
            errors:[]
        };
    }
    
    init() {
        this.vm = {
            errors:[]
        };
        // refresh model with line manager list passed through interface. Not great but necessary to track the selected radio.
        if (this.model && this.lineManagers) {
            this.model = this._.find(this.lineManagers, (lm) => lm.curtinId === this.model.curtinId);
        }

        // auto-select first line manager if only one
        if (this.lineManagers && this.lineManagers.length === 1) {
            this.model = this.lineManagers[0];
        }
    }

    lineManagerSelected() {
        this.vm = {
            errors:[]
        };
    }

    validate() {
        if (this.readonly) {
            return true;
        }

        if (this.lineManagers.length > 1 && (this._.isEmpty(this.model) || this._.isEmpty(this.model.curtinId))) {

            let alternate = this._.filter(this.componentRegistryService.components, { modelName: "alternativeOfficer" });

            if (alternate[0].curtinId) {
                this.model = this.primaryLineManager[0];
                this.lineManagerSelected();
            } else {
                this.vm.errors = [`Please select a line manager`];
            }
        } else {
            this.vm.errors = [];
        }

        return this.vm.errors.length === 0;
    }

    validateAsync() {
        return this.getPromise(this.validate());
    }
}

LineManagerSelectController.$inject = ['_', 'componentRegistryService','$q', 'userService'];

let LineManagerSelectComponent = {
    bindings: {
        lineManagers: '<',
        readonly: '<',
        modelName:'@',
        primaryLineManager: '<'
    },
    templateUrl: 'app/disclose/conflictOfInterest/components/line-manager-select/line-manager-select.html',
    controller: LineManagerSelectController
};

export default LineManagerSelectComponent;


// WEBPACK FOOTER //
// ./app/disclose/conflictOfInterest/components/line-manager-select/line-manager-select.component.js